import React from "react";

class CategoryTypeIndicator extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fill } = this.props;
    return (
      <svg width="20" height="20">
        <circle cx="10" cy="10" r="8" fill={fill} />
      </svg>
    );
  }
}

export default CategoryTypeIndicator;



// WEBPACK FOOTER //
// ./src/components/CategoryTypeIndicator.js